import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-manage-preview-latest-alerts',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  templateUrl: './manage-preview-latest-alerts.component.html',
  styleUrl: './manage-preview-latest-alerts.component.scss'
})
export class ManagePreviewLatestAlertsComponent {
  @Input() alerts: any[] = [];

  @Output() alertClick = new EventEmitter<any>();

  openAlert(alert: any): void {
    this.alertClick.emit(alert);
  }
}